import React, { useState } from "react";
import FluentUiIcon from "../../../../../../assets/fluent-ui-icon";
import { FluentInput } from "../../../../../../components/FluentUI/Fluent-Input";
import PropTypes from "prop-types";
import { DeleteDialog } from "../common-components/delete-dialog";
import { ModifyFormSectionItem } from "./modify-form-section-item";
import { SectionLabelBlurUtil } from "./form-design-util";

export const ModifyFormSection = ({
  subForm,
  RenameSection,
  DeleteSection,
  allForms,
  currentForm,
  setAllForms,
  onValidationChange,
}) => {
  const [dialog2, setDialog2] = useState(false);
  const [sectionValidation, setSectionValidation] = useState("");

  const OnDeleteSection = () => {
    DeleteSection(subForm.DisplayOrder);
    setDialog2(false);
  };

  const OnSectionBlur = (e) => {
    const allSections = currentForm.SubForms.map((s) => ({
      Label: s.Label,
      DisplayOrder: s.DisplayOrder,
    }));
    const { message, sectionName } = SectionLabelBlurUtil(
      allSections,
      subForm.DisplayOrder,
      e.target.value
    );

    if (!message) {
      RenameSection(sectionName, subForm.DisplayOrder);
    }
    setSectionValidation(message);
    onValidationChange?.(subForm.DisplayOrder, message);
  };

  return (
    <div className="modify-form-content-section">
      <div className="modify-form-content-section-head">
        {subForm.Label}
        <div onClick={() => setDialog2(true)}>
          <FluentUiIcon name={"DeleteRegular"} color={"#424242"} size={20} />
        </div>
      </div>
      <div className="modify-form-content-section-input">
        <FluentInput
          defaultValue={subForm?.Label}
          placeholder={"Untitled Section"}
          onBlur={OnSectionBlur}
          validationMessage={sectionValidation}
        ></FluentInput>
      </div>
      {subForm?.Fields.map((field, index) => (
        <ModifyFormSectionItem
          number={field.DisplayOrder}
          key={field.DisplayOrder}
          field={field}
          subForm={subForm}
          allForms={allForms}
          currentForm={currentForm}
          setAllForms={setAllForms}
          fieldLength={subForm?.Fields?.length}
          index={index}
        />
      ))}
      {dialog2 && (
        <DeleteDialog
          identifier="Section"
          open={dialog2}
          OnCancel={() => setDialog2(false)}
          OnDelete={OnDeleteSection}
        ></DeleteDialog>
      )}
    </div>
  );
};

ModifyFormSection.propTypes = {
  subForm: PropTypes.object,
  RenameSection: PropTypes.func,
  DeleteSection: PropTypes.func,
  allForms: PropTypes.object,
  currentForm: PropTypes.object,
  setAllForms: PropTypes.func,
  onValidationChange: PropTypes.func,
};
